import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';
import './Home.css';

const Home = () => {
    return (
        <div className="home-container">
            <SEO description="The first community-driven database of veterinary pricing. Upload vet bills, compare costs, and make informed decisions about your pet's care." />
            <div className="home-shell">
                <section className="home-hero">
                    <div className="home-hero-copy">
                        <span className="home-eyebrow">Veterinary price transparency</span>
                        <h1>VetBill</h1>
                        <p className="home-subheadline">
                            The first community-driven database of <span className="home-keep-together">veterinary pricing.</span>
                        </p>
                        <p className="home-supporting-copy">
                            Upload veterinary bills and estimates. Compare real veterinary costs. Make informed decisions about your pet's care.
                        </p>
                        <div className="home-buttons">
                            <Link to="/upload/step1" className="primary-home-button" aria-label="Upload a Bill">
                                Upload a Bill
                            </Link>
                            <Link to="/browse" className="secondary-home-button" aria-label="Browse Hospitals">
                                Browse Hospitals
                            </Link>
                        </div>
                    </div>
                    <div className="home-hero-panel" aria-label="Example veterinary price comparison">
                        <div className="home-panel-header">
                            <span>Real cost comparison</span>
                            <strong>Community data</strong>
                        </div>
                        <div className="home-price-row">
                            <span>Office visit</span>
                            <strong>$64.50</strong>
                        </div>
                        <div className="home-price-row">
                            <span>Blood tests</span>
                            <strong>$192.62</strong>
                        </div>
                        <div className="home-price-row">
                            <span>X-rays</span>
                            <strong>$48.38 - $131.15</strong>
                        </div>
                    </div>
                </section>

                <section className="home-explainer">
                    <p>
                        Veterinary costs can vary dramatically between hospitals, even within the same city. VetBill helps pet owners understand real-world pricing using data contributed by other pet owners.
                    </p>
                </section>

                <section className="home-value-grid" aria-label="How VetBill helps pet owners">
                    <div>
                        <span>1</span>
                        <h2>Upload bills and estimates</h2>
                        <p>Contribute real documents that help build transparent veterinary pricing data.</p>
                    </div>
                    <div>
                        <span>2</span>
                        <h2>Compare real costs</h2>
                        <p>Browse hospitals and see prices backed by community-uploaded evidence.</p>
                    </div>
                    <div>
                        <span>3</span>
                        <h2>Make better decisions</h2>
                        <p>Understand pricing before choosing care for your pet.</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Home;
